import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { msg, MsgProps } from "src/i18n/Msg";
import { Calendar } from "src/components/atoms/Calendar";
import styles from "src/components/molecules/CalendarInput/styles.module.css";
import CalendarIcon from "src/assets/icons/calendar.svg";
import { isValidDate } from "src/utils/date";
import { format } from "date-fns";
import { Input } from "src/components/atoms/Input";

type Props = {
  label?: MsgProps;
  value: string;
  onchangeInput: (value: string) => void;
  calendarChange: (value: Date | null) => void;
  error?: string;
  className?: string;
  errorWithoutTranslation?: boolean;
};

export const CalendarInput: React.FC<Props> = ({
  label,
  value,
  onchangeInput,
  calendarChange,
  error,
  className,
  errorWithoutTranslation,
}) => {
  const intl = useIntl();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isValidD = isValidDate(value);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\D/g, "").slice(0, 8);
    const day = raw.slice(0, 2);
    const month = raw.slice(2, 4);
    const year = raw.slice(4, 8);
    const formatted = [day, month, year].filter(Boolean).join(".");
    onchangeInput(formatted);
  };
  return (
    <div className={styles.calendarInput} ref={containerRef}>
      <Input
        value={value}
        error={error}
        label={label}
        onChange={handleInputChange}
        iconClick={() => setIsOpen((prev) => !prev)}
        placeholder={msg(intl, {
          id: "components.forms.AddEventForm.date.placeholder",
        })}
        className={className}
        rightIconSrc={CalendarIcon}
        errorWithoutTranslation={errorWithoutTranslation}
      />

      {isOpen && (
        <div className={styles.calendar}>
          <Calendar
            value={
              isValidD
                ? new Date(value.split(".").reverse().join("-"))
                : new Date()
            }
            onChange={(date) => {
              if (date) {
                const formatDate = format(date, "dd.MM.yyyy");
                onchangeInput(formatDate);
                calendarChange(date);
              }
            }}
          />
        </div>
      )}
    </div>
  );
};
